<template>
  <div class="header-container">
    <div class="title">遂宁市智慧物流生态链平台可视化分析中心</div>
    <div class="current-date">
      <div class="date">{{date + " " + zhWeek}}</div>
      <div class="time">{{time}}:<span class="seconds">{{fromatSeconds}}</span></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      week: 0,
      month: 12,
      day: 0,
      hours: 12,
      minutes: 0,
      seconds: 0
    }
  },

  computed: {
    zhWeek () {
      const arr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      return arr[this.week]
    },

    date () { // MM月dd日
      const m = Number(this.month) >= 10 ? this.month : '0' + this.month
      const d = Number(this.day) >= 10 ? this.day : '0' + this.day
      return m + '月' + d + '日'
    },

    time () { // hh:mm
      const h = Number(this.hours) >= 10 ? this.hours : '0' + this.hours
      const m = Number(this.minutes) >= 10 ? this.minutes : '0' + this.minutes
      return h + ':' + m
    },

    fromatSeconds () {
      return this.seconds < 10 ? '0' + this.seconds : this.seconds
    }
  },

  created () {
    setInterval(this.getCurrentDate(), 1000)
  },

  methods: {
    getCurrentDate () {
      const currentDate = new Date()
      this.week = currentDate.getDay()
      this.month = currentDate.getMonth() + 1
      this.day = currentDate.getDate()
      this.hours = currentDate.getHours()
      // console.log(this.hours)
      this.minutes = currentDate.getMinutes()
      this.seconds = currentDate.getSeconds()
      return this.getCurrentDate
    }
  }
}
</script>

<style lang="less" scoped>
.header-container {
  position: relative;
  height: 131px;
  &::after {
    position: absolute;
    left: 0;
    top: -20px;
    content: '';
    width: 100%;
    height: 300px;
    background-image: url("~assets/image/header.gif");
    background-size: 100% 100%;
  }
}

.title {
  position: absolute;
  top: 38px;
  width: 100%;
  font-size: 48px;
  font-weight: bold;
  color: #FFFFFF;
  text-align: center;
  line-height: 56px;
  font-family: "SourceHanSerifCN-Bold";
}

.current-date {
  position: absolute;
  right: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #34dee5;
  .date {
    font-size: 34px;
    font-weight: bold;
  }
  .time {
    margin-left: 10px;
    font-size: 80px;
    font-family: "DS-DIGIT";
    .seconds {
      display: inline-block;
      width: 101.82px;
    }
  }
}
</style>